import { Component, ViewChild, OnInit, ElementRef, NgZone, HostListener } from '@angular/core';
import { trigger, transition, query, style, group, animate } from '@angular/animations';
import { MatSidenav, MatDrawerToggleResult } from '@angular/material';
import { HeaderService } from './components/header/header.service';
import { UserService } from './shared/user.service';
import { TokenService } from './shared/token.service';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '../environments/environment';
import { PicasaServiceService } from './components/upload/upload-providers-services/picasa-service.service';
import { HttpHeaders } from '@angular/common/http';
import { PAGE_VIEW } from './consts/appConsts';
import { AnalyticsService } from './shared/analytics.service';

export const routerTransition = trigger('routerTransition', [
    transition('* <=> *', [
        /* order */
        // /* 1 */ query(':enter, :leave', style({ position: 'fixed', width:'100%' })
        //   , { optional: true }),
        /* 2 */ group([
        // block executes in parallel
        query(
            ':enter',
            [style({ opacity: '0' }), animate('.5s ease-in-out', style({ opacity: '1' }))],
            { optional: true }
        ),
        query(
            ':leave',
            [style({ opacity: '1' }), animate('.5s ease-in-out', style({ opacity: '0' }))],
            { optional: true }
        ),
    ]),
    ]),
]);

const LUPA_HEB = 'לופה';
@Component({
    // tslint:disable-next-line:component-selector
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [routerTransition],
})
export class AppComponent implements OnInit {
    title = LUPA_HEB;
    version = environment.version;

    @ViewChild('lupaSiteFrame', { read: ElementRef })
    lupaSiteFrame: ElementRef;
    //@HostListener('window:storage')
    @HostListener('window:storage', ['$event'])
    //@HostListener('window:storage')
    onStorageChange(event: StorageEvent) {

        if (event.key === 'localStorage' || event.key === 'oauth_token') {
            let accessToken = window.localStorage.getItem('oauth_token');
            console.log(accessToken);
            //get albums
            const headers = new HttpHeaders()
                .set('X-Requested-With', 'XMLHttpRequest')
                .set('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8')
                .set('Authorization', 'Bearer ' + accessToken);
            this.picasaService.getAllAlbums(headers, '');
            // console.log(`test --- ${event.key}`);

        }
    }

    @ViewChild('sidenav')
    sidenav: MatSidenav;
    token: string;
    isUser = false;
    openMenu: boolean;
    isPageRender = false;

    constructor(
        private headerService: HeaderService,
        private userService: UserService,
        private tokenService: TokenService,
        private router: Router,
        private zone: NgZone,
        private picasaService: PicasaServiceService,
        private analytics:AnalyticsService,
    ) {       
        this.router.events.forEach(item=>{
            if (item instanceof NavigationEnd)
            {              
                let urlParts = item.urlAfterRedirects? item.urlAfterRedirects.split('/') : item.urlAfterRedirects;
                analytics.sendPageViewEvent(PAGE_VIEW, urlParts && urlParts.length!=0? urlParts[urlParts.length -1] : item.urlAfterRedirects);
            }
        })
    }

    getState(outlet) {
        return outlet.activatedRouteData.state;
    }
    ngOnInit() {
        localStorage.removeItem("lock");
        this.token = this.tokenService.token;
        this.tokenService.tokenChange.subscribe(token => {
            if (token) {
                this.token = token;
            }
        });

        this.userService.$userData.subscribe(userData => {
            this.isUser = userData ? true : false;
            if (this.isUser) {

            }
        });
        this.headerService.$toggleSideMenu.subscribe(() => {
            this.toggleMenu();
        });

        console.log("version : " + this.version);
    }

    toggleMenu() {
        this.sidenav.toggle().then((value: MatDrawerToggleResult) => {
            this.openMenu = value === 'open';
        });
    }

    login(e) {
        e.preventDefault();
        this.headerService.setLoginIframePage(true);
        this.toggleMenu();
        this.userService.openLogin().subscribe(userData => {
            if (userData) {
                this.headerService.setUserName(userData.firstName);
                this.headerService.setLoginIframePage(false);
            }

        });
    }
    logout(e) {
        e.preventDefault();
        this.sidenav.toggle();
        this.userService.openLogout().subscribe(data => {
            if (data && data.status === 'success') {
                this.tokenService.clearTokenStorage();
                location.href = 'https://www.lupa.co.il';
                // this.userService.clearUserData();
                // this.headerService.setUserName("");
            }
        });
    }
    goToNewBook(e) {
        e.preventDefault();
        this.tokenService.clearTokenStorage();
        setTimeout(() => {
            this.router.navigate(['/create'], {
                queryParams: { token: this.tokenService.token },
                replaceUrl: true,
            });
        });
    }

    createBook() {
        if (!this.tokenService.isLoggedIn()) {
            if (this.tokenService.hasEventToken()) {
                this.userService.openLogin().subscribe(userData => {
                    if (userData) {
                        this.headerService.setUserName(userData.firstName);
                    }
                });
            }
            else {
                setTimeout(() => {
                    this.router.navigate(['/create'], {
                        // queryParams: { token: this.tokenService.token },
                        replaceUrl: true,
                    });
                });
            }
        }
        else {
            //this.tokenService.clearTokenStorage();
            this.tokenService.event_token = '';
            this.headerService.$toggleSideMenu.next(false);
            this.headerService.setBookName('');
            setTimeout(() => {
                this.router.navigate(['/create'], {
                    queryParams: { token: this.tokenService.token },
                    replaceUrl: true,
                });
            });
        }
    }
}
